import { PaymentMethod } from '../constants';
export const isValidOffer = (offer) => {
    if (!offer || typeof offer !== 'object')
        return false;
    const potentialOffer = offer;
    return ('name' in potentialOffer &&
        typeof potentialOffer.name === 'string' &&
        'title' in potentialOffer &&
        typeof potentialOffer.title === 'object' &&
        potentialOffer.title !== null &&
        'value' in potentialOffer.title &&
        typeof potentialOffer.title.value === 'string' &&
        'description' in potentialOffer &&
        typeof potentialOffer.description === 'object' &&
        potentialOffer.description !== null &&
        'value' in potentialOffer.description &&
        typeof potentialOffer.description.value === 'string' &&
        'offerType' in potentialOffer &&
        typeof potentialOffer.offerType === 'object' &&
        potentialOffer.offerType !== null &&
        'value' in potentialOffer.offerType &&
        typeof potentialOffer.offerType.value === 'string' &&
        'offerAmount' in potentialOffer &&
        typeof potentialOffer.offerAmount === 'object' &&
        potentialOffer.offerAmount !== null &&
        'value' in potentialOffer.offerAmount &&
        typeof potentialOffer.offerAmount.value === 'string');
};
const isValidModelImage = (image) => {
    if (!image || typeof image !== 'object')
        return false;
    const img = image;
    return ('width' in img &&
        typeof img.width === 'string' &&
        'height' in img &&
        typeof img.height === 'string' &&
        'src' in img &&
        typeof img.src === 'string' &&
        'alt' in img &&
        typeof img.alt === 'string');
};
const isValidDefaultTransmission = (transmission) => {
    if (!transmission || typeof transmission !== 'object')
        return false;
    const trans = transmission;
    return ('detKey' in trans &&
        trans.detKey &&
        'value' in trans.detKey &&
        !!trans.detKey.value &&
        'defaultExteriorColor' in trans &&
        'specialRateCriterion' in trans);
};
const isValidCta = (cta) => {
    if (!cta || typeof cta !== 'object')
        return false;
    const potentialCta = cta;
    return ('href' in potentialCta &&
        typeof potentialCta.href === 'string' &&
        'linkType' in potentialCta &&
        typeof potentialCta.linkType === 'string' &&
        'hrefSearch' in potentialCta &&
        typeof potentialCta.hrefSearch === 'string');
};
export const isValidModelData = (data) => {
    if (!data || typeof data !== 'object')
        return false;
    const model = data;
    // Check ModelInformation properties
    const hasModelInfo = 'modelName' in model &&
        typeof model.modelName === 'string' &&
        'modelYear' in model &&
        typeof model.modelYear === 'string' &&
        'modelKey' in model &&
        typeof model.modelKey === 'string' &&
        'trimName' in model &&
        typeof model.trimName === 'string' &&
        'trimKey' in model &&
        typeof model.trimKey === 'string' &&
        'transmissionId' in model &&
        typeof model.transmissionId === 'string' &&
        'transmissionKey' in model &&
        typeof model.transmissionKey === 'string' &&
        'exteriorColorKey' in model &&
        typeof model.exteriorColorKey === 'string' &&
        'interiorColorKey' in model &&
        typeof model.interiorColorKey === 'string';
    if (!hasModelInfo)
        return false;
    // Check image
    if (!('image' in model) || !isValidModelImage(model.image))
        return false;
    // Check financials
    if (!('financials' in model) || typeof model.financials !== 'object')
        return false;
    const financials = model.financials;
    const hasFinancials = 'defaultFinancePaymentFrequency' in financials &&
        typeof financials.defaultFinancePaymentFrequency === 'string' &&
        'defaultLeasePaymentFrequency' in financials &&
        typeof financials.defaultLeasePaymentFrequency === 'string' &&
        'defaultPaymentMethod' in financials &&
        typeof financials.defaultPaymentMethod === 'string' &&
        'bonusOffers' in financials &&
        Array.isArray(financials.bonusOffers);
    if (!hasFinancials)
        return false;
    // Check bonus offers structure
    const bonusOffers = financials.bonusOffers;
    const hasValidBonusOffers = bonusOffers.every(offer => {
        if (!offer || typeof offer !== 'object')
            return false;
        const bonusOffer = offer;
        return ('paymentMethod' in bonusOffer &&
            Object.values(PaymentMethod).includes(bonusOffer.paymentMethod) &&
            'offers' in bonusOffer &&
            Array.isArray(bonusOffer.offers));
    });
    if (!hasValidBonusOffers)
        return false;
    // Check defaultTransmission
    if (!('defaultTransmission' in model) || !isValidDefaultTransmission(model.defaultTransmission)) {
        return false;
    }
    // Check exploreModelCta (optional)
    if ('exploreModelCta' in model && model.exploreModelCta !== undefined) {
        if (!isValidCta(model.exploreModelCta))
            return false;
    }
    return true;
};
